/**
 * List of public routes that
 * do not require authentication
 */
export const PUBLIC_ROUTES = {
  signIn: '/sign-in',
  SignUp: `/sign-up`,
  forgotPassword: '/forgot-password',
  passwordCreate: '/password-create/:code',
  confirmPasswordReset: '/confirm-reset-password/:code',
  userAccountActivation: '/user-account-verification/:code',
  userEmailVerification: '/user-email-verification/:code',
  magicLogin: '/magic-login/:token',
  acceptInvitation: '/accept-invitation',
  publicPoliciesList: '/public-policies',
  testAgent: '/test-agent',
  generateOtpToken: '/generateOtpToken',
  azureConnect: '/auth/azure-connect',
  azureLogin: '/auth/azure-login',

  // For testing purpose, should remove
  dashboardPublic: '/dashboard-public',
  appInit: '/app-init',
  privacy: '/privacy',
  termsOfUse: '/terms',
};
